import Papa from "papaparse";
import { use, useEffect, useRef, useState } from "react";
import { set, useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import useApi from "../../hooks/useApi";
import "./user-entry.component.scss";
import FetchUpdateUserEntry from "./fetch-update-user.component";

type FormData = {
  name: string;
  email: string;
  role_id: number[];
  user_type: string;
  password: string;
  isActive: boolean;
};
const UserEntry = () => {
  const [data, setData] = useState<any[]>([]);
  const { post, put } = useApi();
  const fileInputRef = useRef(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorShow, setErrorShow] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [userId, setUserId] = useState<number | null>(null);
  const [roles, setRoles] = useState<any[]>([]);
  useEffect(() => {}, []);

  const handleClearFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // or ""
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<FormData>();

  useEffect(() => {
    let isValid = true;
    data?.forEach((element) => {
      if (element) {
        if (
          !element.password ||
          element.password === undefined ||
          element.password === null ||
          element.password === ""
        ) {
          console.log("Password is required for user", element);
          isValid = false;
        }
      }
    });
    if (isValid && !isEdit) {
      handleSaveUser(data);
    } else if (!isValid) {
      setErrorShow((prev) => [...prev, "Password is required for all users"]);
    }
  }, [data]);

  function hasKey(obj, key) {
    return Object.keys(obj).some(
      (key) => key.toLowerCase() === key.toLowerCase()
    );
  }

  function getKeyAndValue(obj, key1) {
    const match = Object.keys(obj).find(
      (key) => key.toLowerCase() === key1.toLowerCase()
    );
    if (match) {
      return { key: match.toLowerCase(), value: obj[match] };
    }
    return { value: null };
  }
  const resetAll=()=>{
    reset();
    setData([]);
    setUserId(null);
    setIsEdit(false);
    setRoles([]);
    setErrorShow([]);
    handleClearFile();

  }

  const getFormFields = () => {
    return (
      <div className="container mt-4">
        <div className="row align-items-center mb-3">
          <div className="col-md-3 text-start">
            <label>Name</label>
          </div>
          <div className="col-md-9">
            <input
              className="form-control text-start"
              type="text"
              {...register("name", { required: "Name is required" })}
              placeholder="Name"
            />
          </div>

          {errors.name && <p style={{ color: "red" }}>{errors.name.message}</p>}
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-md-3 text-start">
            <label>Email</label>
          </div>
          <div className="col-md-9">
            <input
              className="form-control text-start"
              type="text"
              {...register("email", {
                required: "Email is required",
              })}
              placeholder="Email"
            />
          </div>

          {errors.email && (
            <p style={{ color: "red" }}>{errors.email.message}</p>
          )}
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-md-3 text-start">
            <label>Password</label>
          </div>
          <div className="col-md-9">
            <input
              className="form-control text-start"
              type="text"
              {...register("password", {
                required: "Password is required",
              })}
              placeholder="Password"
            />
          </div>

          {errors.password && (
            <p style={{ color: "red" }}>{errors.password.message}</p>
          )}
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-md-3 text-start">
            <label>Role ID</label>
          </div>
          <div className="col-md-9">
            <input
              className="form-control text-start"
              type="number"
              defaultValue={3}
              {...register("role_id", {})}
              placeholder="Role ID (default 3)"
              style={{ display: isEdit? "none" : "block" }}
             
            />
           {isEdit && <table className="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Role ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Description</th>
                </tr>
              </thead>
              <tbody>
                {roles.map((role, index) => (
                  <tr key={index}>
                    <td>{role.id}</td>
                    <td>{role.name}</td>
                    <td className="text-start">{role.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>}
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-md-3 text-start">
            <label> User type</label>
          </div>
          <div className="col-md-9">
            <input
              className="form-control text-start"
              type="text"
              {...register("user_type", {})}
              defaultValue={"WORLDCC_STAFF"}
              placeholder="User Type (default WORLDCC_STAFF)"
              disabled={isEdit}
            />
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-md-3 text-start">
            <label htmlFor="isActiveCheckbox" className="form-label">
              Is Active User
            </label>
          </div>
          <div className="col-md-2">
            <input
              type="checkbox"
              id="isActiveCheckbox"
              className="form-check-input checkActive"
              {...register("isActive", {})}
              defaultChecked
            />
          </div>
          <div className="col-md-4">
            <span className="activeUser">Active </span>
            <span className="inactiveUser">Inactive </span>
          </div>
        </div>

        <button className="btn" type="submit">
          Save User
        </button>
         <button className="btn" type="button" onClick={resetAll}>
          Cancel / Reset
        </button>
      </div>
    );
  };
  console.log("err", errorShow);
  const handleSaveUser = (data: any) => {
    setErrorShow([]);
    setIsSuccess(false);
    if (data != null && data.length > 0) {
      for (const record of data) {
        if (hasKey(record, "email") && hasKey(record, "name")) {
          const userData = {
            email: getKeyAndValue(record, "email").value,
            password: getKeyAndValue(record, "password").value, //generatePassword(),
            name: getKeyAndValue(record, "name").value,
            membership_type: "NOT_APPLICABLE",
            user_type:
              getKeyAndValue(record, "user_type").value || "WORLDCC_STAFF",
            role_id: getKeyAndValue(record, "role_id").value
              ? [getKeyAndValue(record, "role_id").value]
              : [3],
            is_active:
              getKeyAndValue(record, "isActive").value === null
                ? true
                : getKeyAndValue(record, "isActive").value,
          };
          post("users/", userData)
            .then((response) => {
              if (response && response.status !== 200) {
                setErrorShow((prev) => [
                  ...prev,
                  "Error in saving user - " + userData.email,
                ]);
              }
              if (response && response?.data?.id) {
                updateUserRole(response?.data?.id, userData);
              }

              console.log("User data saved successfully:", response);
            })
            .catch((error) => {
              console.error("Error saving user data:", error);
              setErrorShow((prev) => [
                ...prev,
                "Error in saving user - " + userData.email,
              ]);
            });
        } else {
          console.log("key not found name/email");
          setErrorShow((prev) => [...prev, "key not found name/email"]);
        }
      }
      handleClearFile();
      setData([]);
      setUserId(null);
      reset();
    } else {
      console.log("No data to save");
    }
  };

  const handleUpdateUser = (data: any) => {
    setErrorShow([]);
    setIsSuccess(false);
    if (data != null && data.length > 0) {
      for (const record of data) {
        if (hasKey(record, "email") && hasKey(record, "name")) {
          const userData = {
            id: userId,
            email: getKeyAndValue(record, "email").value,
            password: getKeyAndValue(record, "password").value, //generatePassword(),
            name: getKeyAndValue(record, "name").value,
            membership_type: "NOT_APPLICABLE",
            user_type:
              getKeyAndValue(record, "user_type").value || "WORLDCC_STAFF",
            role_id: getKeyAndValue(record, "role_id").value
              ? [getKeyAndValue(record, "role_id").value]
              : [3],
            is_active:
              getKeyAndValue(record, "isActive").value === null
                ? true
                : getKeyAndValue(record, "isActive").value,
          };
          put(`users/${userId}`, userData)
            .then((response) => {
              if (response && response.status !== 200) {
                setErrorShow((prev) => [
                  ...prev,
                  "Error in saving user - " + userData.email,
                ]);
              }
              if (response && response?.data?.id) {
                updateUserRole(response?.data?.id, userData);
              }

              console.log("User data saved successfully:", response);
            })
            .catch((error) => {
              console.error("Error saving user data:", error);
              setErrorShow((prev) => [
                ...prev,
                "Error in saving user - " + userData.email,
              ]);
            });
        } else {
          console.log("key not found name/email");
          setErrorShow((prev) => [...prev, "key not found name/email"]);
        }
      }
      handleClearFile();
      setData([]);
      setUserId(null);
      reset();
    } else {
      console.log("No data to save");
    }
  };

  const updateUserRole = (userId, userData) => {
    const payload = {
      user_id: userId,
      role_ids: userData.role_id || [3],
    };

    console.log("Payload for user role:", payload);
    post(`users/${userId}/roles`, payload)
      .then((response) => {
        if (response && response.status !== 200) {
          setErrorShow((prev) => [
            ...prev,
            "Error in saving role for - " + userData.email,
          ]);
        }
        console.log("User role saved successfully:", response, errorShow);
        if (errorShow.length === 0) {
          setIsSuccess(true);
        }
      })
      .catch((error) => {
        console.error("Error saving user role:", error);
        setErrorShow((prev) => [
          ...prev,
          "Error in saving role for - " + userData.email,
        ]);

        setIsSuccess(false);
      });
  };

  const generatePassword = (length = 16) => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const digits = "0123456789";
    const special = "_-@#$()!";
    const allChars = upper + lower + digits + special;

    let password = "";
    for (let i = 0; i < length; i++) {
      const randIndex = Math.floor(Math.random() * allChars.length);
      password += allChars[randIndex];
    }

    return password;
  };

  const handleExcelUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          //   header: 1,
          defval: "",
        });
        setData(jsonData);

        console.log("Excel Data:", jsonData);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleCSVUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          console.log("CSV Data:", results.data);
          setData(results.data);
        },
      });
    }
  };

  const onSubmit = (data: FormData) => {
    console.log("Form Submitted:", data);
    // Reset form if needed
    setData((prevData) => [...prevData, data]);
    if (isEdit && userId) {
      handleUpdateUser([data]);
    } else {
      handleSaveUser([data]);
    }
  };

  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const ext = file.name.split(".").pop()?.toLowerCase();
      if (ext === "csv") handleCSVUpload(event);
      else if (["xls", "xlsx", "ods"].includes(ext)) handleExcelUpload(event);
      else alert("Unsupported file type");
    }
  };

  const fetchUser = () => {
    handleOpenModal();
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = (data?: any) => {
    setShowModal(false);
    setIsEdit(false);
    setUserId(null);
    if (data) {
      console.log("User data from modal:", data);
      setValue("email", data.email);
      setValue("name", data.name);
      setValue("user_type", data.user_type);
      setValue("role_id", data.role_id);
      setValue("isActive", data.is_active || true);
      setValue("password", data.password);
      setUserId(data.id);
      setRoles(data.roles || []);
      setIsEdit(true);
    }
  };
  return (
    <div className="user-entry">
      <form onSubmit={handleSubmit(onSubmit)} className="user-form">
        <div className="container mt-4 headbtn">
          <h5>Add User By Filling Details below</h5>
          <button type="button" className="btn" onClick={fetchUser}>
            Fetch/Update User
          </button>
        </div>
        {getFormFields()}

        <div className="container mt-4 uploadDiv">
          <h5>or Upload User Details File here</h5>
          <input
            ref={fileInputRef}
            className="filecontrol"
            type="file"
            accept=".csv,.xlsx,.xls,.ods"
            onChange={handleUpload}
          />
        </div>

        {/* <button className="btn" onClick={handleSaveUser}>
          Save User
        </button> */}

        {isSuccess && isEdit && (
          <div className="success"> User Updated Successfully</div>
        )}
        {isSuccess && !isEdit && (
          <div className="success"> User Added Successfully</div>
        )}

        {[...new Set(errorShow)].length > 0 && (
          <div className="error">
            {[...new Set(errorShow)].map((error, index) => (
              <div key={index}>
                {error}
                <br />
              </div>
            ))}
          </div>
        )}
      </form>
      {/* Render Modal when showModal is true */}
      {showModal && (
        <FetchUpdateUserEntry show={true} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default UserEntry;
